<template>
  <b-row>
    <b-col v-if="isLoading && items.length === 0">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row>
        <b-col cols="12">
          <b-row>
            <b-col class="text-right">
              <router-link
                :to="{ name: 'EXSBItemBrandCreate' }"
                class="btn btn-primary">{{$t('buttons.create')}}</router-link>
            </b-col>
          </b-row>
          <b-card>
            <div v-if="items.length > 0">
              <table class="table table-sm table-striped table-hover">
                <thead>
                <tr>
                  <th>{{$t('views.exsbitembrand.list.brandTitle')}}</th>
                  <th />
                </tr>
                </thead>
                <tbody>
                <tr
                        v-for="item in items"
                        :key="item['@id']">
                  <td>
                    {{ item['brandTitle'] }}
                  </td>
                  <td>
                    <router-link :to="{name: 'EXSBItemBrandUpdate', params: { id: item['@id'] }}">
                      <button class="float-right btn btn-link fa fa-pencil" v-b-tooltip.hover :title="$t('buttons.edit')" aria-hidden="true" />
                    </router-link>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <p v-else>{{ $t('views.exsbitembrand.list.noBrands') }}</p>
            <div v-if="view">
              <pagination
                :view="view"
                @getPage="getPage($event)"
              ></pagination>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { checkPagePermission } from '@/utils/checkRoles.js'
import Loader from '../../../Layout/Loader'
import Pagination from '../../../Layout/Pagination'

export default {
  components: {
    Loader,
    Pagination
  },

  computed: mapGetters({
    deletedItem: 'exsbitembrand/del/deleted',
    error: 'exsbitembrand/list/error',
    items: 'exsbitembrand/list/items',
    isLoading: 'exsbitembrand/list/isLoading',
    view: 'exsbitembrand/list/view'
  }),

  beforeCreate () {
    checkPagePermission('warehouses', 'EXSBItemBrandList')
  },

  created () {
    this.getPage()
  },

  methods: mapActions({
    getPage: 'exsbitembrand/list/default'
  })
}
</script>
